import { OAuthLogger } from 'angular-oauth2-oidc';

const suppressedErrorPatterns = ['refreshing token'];

export class CustomOAuthLogger extends OAuthLogger {
  debug(message?: string, ...optionalParams: unknown[]): void {
    console.debug(message, ...optionalParams);
  }

  info(message?: string, ...optionalParams: unknown[]): void {
    console.info(message, ...optionalParams);
  }

  log(message?: string, ...optionalParams: unknown[]): void {
    console.log(message, ...optionalParams);
  }

  warn(message?: string, ...optionalParams: unknown[]): void {
    console.warn(message, ...optionalParams);
  }

  error(message?: string, ...optionalParams: unknown[]): void {
    if (suppressedErrorPatterns.some((pattern) => message?.toLowerCase().includes(pattern))) {
      console.warn(message, ...optionalParams);
      return;
    }
    console.error(message, ...optionalParams);
  }
}
